import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        vendor: {},
        vendors: {data: [], current_page: 1, total: 0, per_page: 10},
        payments: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {
                    vendor_type_id: [],
                    amount: [],
                    effective_date: [],
                    project_id: []
                }
            }
        },
        has_errors: false,
        loading: false,
        dialogVisible: false,
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        vendors: state => state.vendors,
        vendor: state => state.vendor,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        loading: state => state.loading,
        payments: state => state.payments
    },
    mutations: {
        setLoading(state, status) {
            state.loading = status
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setVendors(state, data) {
            state.vendors = data;
        },
        setVendor(state, data) {
            state.vendor = data;
        },
        setVendorPayments(state, data) {
            state.payments = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            vendor_type_id: [],
                            amount: [],
                            effective_date: [],
                            project_id: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async createVendor({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createVendor(data);
                ElMessage.success('Vendor created successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async getVendors({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getVendors(filters);
                commit('setVendors', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },
        async getVendor({commit}, filters) {
            try {
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getVendor(filters);
                commit('setVendor', response?.data);
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },


        async createVendors({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.createVendor(data);
                dispatch('getVendors', {
                    paginate: true
                })
                ElMessage.success('Vendor created successfully!');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response.status === 422 ? e.response : {
                    data: {
                        errors: {
                            vendor_type_id: [],
                            amount: [],
                            effective_date: [],
                            project_id: []
                        }
                    }
                })
                ElMessage.error(e.response.data.message);
            }
        },
        async editVendor({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.editVendor(data);
                dispatch('getVendors', {
                    paginate: true
                });
                ElMessage.success('Vendor updated successfully!');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false)
                commit('setErrors', e.response.status === 422 ? e.response : {
                    data: {
                        errors: {
                            vendor_type_id: [],
                            amount: [],
                            effective_date: [],
                            project_id: []
                        }
                    }
                })
                commit('hasErrors', true)
                ElMessage.error(e.response.data.message);
            }
        },

        async deleteVendor({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                await api.deleteVendor(data);
                dispatch('getVendors', {
                    paginate: true
                });
                ElMessage.success('Vendor removed successfully!');
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        async exportVendorsReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportVendorsReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Vendors_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },


    }
}
